import guid from '@/lib/guid'
import Vue from 'vue';
export default {
  mInit(state, projects) {
    // Vue.set(state, 'projects', projects);
  },
  mSetDocumentId (state, id) {
    Vue.set(state, 'documentId', id);
  },
  mEnableHAWBLoad(state) {
    Vue.set(state, 'canLoadHAWB', true);
  },
  mSetTab(state, tab) {
    // Vue.set(state, 'config', {...state.config, ...{tab: tab}});
    state.config.tab = tab;
    console.log("state", state);
  },
  mSetMAWB (state, mawb) {
    Vue.set(state, 'mawb', mawb);
    if(mawb) {
      Vue.set(state, 'showForm', true);
      Vue.set(state, 'mawbDocumentImage', mawb.imageUrl);
      Vue.set(state, 'mawbDocumentLoaded', true);
      Vue.set(state, 'documentId', mawb.id);
      state.config.tab = 'master-awb';
    } else {
      Vue.set(state, 'showForm', false);
      Vue.set(state, 'mawbDocumentImage', null);
      Vue.set(state, 'mawbDocumentLoaded', true);
      Vue.set(state, 'documentId', null);
    }
    // console.log("hello state", state);
  },
  mSetHAWBs (state, hawbs) {
    Vue.set(state, 'hawbs', hawbs);
    if(hawbs && hawbs.length) {
      Vue.set(state, 'hawb', hawbs[0]);
      Vue.set(state, 'hawbDocumentImage', hawbs[0].imageUrl);
      Vue.set(state, 'hawbDocumentLoaded', true);
      Vue.set(state, 'canLoadHAWB', true);
      if(!state.mawb) {
        state.config.tab = 'house-awb';
      }
      // console.log("setting hawbs documentType", state.mawb);
      // if(state.mawb && typeof state.mawb.documentType != 'undefined' && state.mawb.documentType != 'MAWB')  {
      //   state.config.tab = 'house-awb';
      // }
    }
  },
  mSetHAWB (state, hawb) {
    Vue.set(state, 'hawb', hawb);
    Vue.set(state, 'hawbDocumentImage', hawb.imageUrl);
    Vue.set(state, 'hawbDocumentLoaded', true);
  },
  mReset(state, hawb) {
    Vue.set(state, 'showForm', false);

    Vue.set(state, 'mawb', {});
    Vue.set(state, 'mawbDocumentImage', null);
    Vue.set(state, 'mawbDocumentLoaded', true);

    Vue.set(state, 'hawbs', []);
    Vue.set(state, 'hawb', {});
    Vue.set(state, 'hawbDocumentImage', null);
    Vue.set(state, 'hawbDocumentLoaded', true);
  }
};
